import { render, staticRenderFns } from "./TenantSelectorBootstrap.vue?vue&type=template&id=2083519e&"
import script from "./TenantSelectorBootstrap.vue?vue&type=script&lang=js&"
export * from "./TenantSelectorBootstrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports